import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPriceCheckList, IPriceCheckListRequest } from '../models/models'

export class PostProductPricesReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productPricesReport',
      requesterInfo,
    })
  }

  public async postProductPricesReport(request: IPriceCheckListRequest): Promise<any[]> {
    return await this.postAsync<any[]>(request)
  }
  public async getMudCode(): Promise<[]> {
    this.props.url = 'admin/product/mudCodeList'
    return await this.getAsync<[]>()
  }
}
